var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58916 8.108L14.9012 1.79501C15.047 1.64911 15.1289 1.45128 15.1289 1.245C15.1289 1.03873 15.047 0.840892 14.9012 0.695L14.4362 0.230003C14.364 0.157679 14.2783 0.1003 14.1839 0.0611496C14.0895 0.0219993 13.9883 0.00184631 13.8862 0.00184631C13.784 0.00184631 13.6828 0.0219993 13.5884 0.0611496C13.4941 0.1003 13.4083 0.157679 13.3362 0.230003L8.03616 5.53001L2.72816 0.222C2.58227 0.0761758 2.38444 -0.0057373 2.17816 -0.0057373C1.97189 -0.0057373 1.77406 0.0761758 1.62816 0.222L1.16316 0.687004C1.01734 0.832897 0.935422 1.03072 0.935422 1.237C0.935422 1.44327 1.01734 1.64111 1.16316 1.787L7.48116 8.106C7.6277 8.25062 7.82529 8.3317 8.03116 8.3317C8.23704 8.3317 8.43463 8.25062 8.58116 8.106L8.58916 8.108Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6a3aa06f063ddcd7e10f1b3fb54f0d3c.svg";
export { ForwardRef as ReactComponent };